

import React, { useContext, useEffect, useState } from 'react'

import Paginator from '../../components/ui/Paginator';

import 'bootstrap-daterangepicker/daterangepicker.css';

import { Reward } from '../../models/interfaces';
import { useNavigate } from "react-router-dom";
import { LoyaltyContext } from '../../context/loyalty/LoyaltyContext';




export const RewardsPage = () => {
    const [buscar, setBuscar] = useState('');
    const [pageActual, setPageActual] = useState<number>(1);
    const { rewards, totalPage, loadRewards, deleteReward } = useContext(LoyaltyContext);
    const navigate = useNavigate();

    useEffect(() => {
        loadRewards(pageActual - 1);
    }, [pageActual])


    const filteredData = rewards.filter((reward) =>
        reward.recompensa.toString().toLowerCase().includes(buscar.toLowerCase())
    );

    const handleNew = () => {
        navigate("/loyalty/rewards/reward");
    }

    const handleEdit = (reward: Reward) => {
        navigate("/loyalty/rewards/reward", { state: { reward } });
    }

    const handleDelete = async (reward_id) => {

        const resp = await deleteReward(reward_id);
        if (resp !== "success") {
            alert(resp);
        }
    }


    return (

        <div className='mt-5 container' style={styles.container}>


            <div className="row justify-content-end mt-5">
                <div className=' col-md-3' style={{ position: 'revert' }}>
                    <input className="form-control" id="search" type="text" placeholder="Buscar" value={buscar} onChange={(e) => setBuscar(e.target.value)} />

                </div>
                <div className=' col-md-1 mt-3 mt-md-0' style={{ position: 'revert' }}>
                    <button type="button" className="btn btn-success" onClick={handleNew}>Nuevo</button>
                </div>
            </div>
            <br></br>
            <table id='rewardTable' className="table table-hover table-striped">
                <thead className="thead-dark">
                    <tr>
                        <th>Recompensa</th>
                        <th>Puntos requeridos</th>
                        <th style={{ textAlign: 'center' }}>Acciones</th>

                    </tr>
                </thead>
                <tbody >
                    {
                        filteredData.length > 0
                            ?
                            filteredData.map(reward => (
                                <tr key={reward.id}>
                                    <td>{reward.recompensa}</td>
                                    <td>{reward.requiere}</td>

                                    {/* <td>{reward.ip}</td>
                            <td>{reward.typeId == 1 ? "Cocina" : "Cajas"}</td> */}

                                    <td style={{ textAlign: 'center', width: '170px' }}>
                                        <button type="button" className="btn btn-primary" onClick={() => handleEdit(reward)}> <i className="bi bi-pencil"></i></button>

                                        <button type="button" className="btn btn-danger" style={{ marginLeft: '10px' }} onClick={() => handleDelete(reward.id)}><i className="bi bi-trash"></i></button>
                                    </td>
                                </tr>
                            ))
                            :
                            <tr> <td colSpan={7} className='text-center'>No hay recompensas configurados.</td></tr>
                    }


                </tbody>
            </table>

            {
                totalPage > 1 ? <Paginator totalPage={totalPage} pageActual={pageActual} onChange={(actual) => setPageActual(actual)} /> : <div />
            }
        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
